import React from "react";
import {
    colors2,
    icons,
    SkeletonLoader,
    UI_BODY_SEMIBOLD_DF,
    UI_CAPTION_SEMIBOLD_DF,
    UI_DISPLAY
} from "oolib";
import { extractErrorMsgs } from "@/utils/useGenErrorMsgBanners";
import styled from "styled-components";

const { WarningCircle } = icons;

const MIN_HEIGHT = 170

export const WidgetLoadingState = ({display}) => {
    return (
      <div
          style={{ 
            padding: "1.6rem",
            height: "100%"
          }}
          >
        <SkeletonLoader style={{
            minHeight: MIN_HEIGHT+"px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            borderRadius: "6px",
        }}/>
      </div>
    )
}

export const WidgetErrorState = ({ display, error, colorPreset }) => {
  const textColor = colorPreset === "purple" 
    ? colors2.purple 
    : colors2.red

  return (
    <div
      className="widget-error-state"
      style={{
        minHeight: MIN_HEIGHT+"px",
        display: "flex",
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        borderRadius: "6px",
        padding: "1.6rem"
      }}
    >
      <div style={{ 
        display: "flex", 
        gap: "4px", 
        alignItems: "center", 
        padding: "1rem",
        backgroundBlendMode: "multiply",
        borderRadius: "0.6rem",
        color: textColor,
        background: 
          colorPreset === "purple" 
          ? "rgba(157, 19, 232, 0.14)"
          : "rgba(196, 23, 23, 0.14)",
        boxShadow: 
          colorPreset === "purple"
          ? `0 0 200px 30px #F2DAFF`
          : `0 0 200px 30px #FFE3E3`
       }}>
        <WarningCircle size={16} style={{ width: "2rem" }}/>
        <UI_CAPTION_SEMIBOLD_DF>
          {error ? extractErrorMsgs(error).join(', ') : display}
        </UI_CAPTION_SEMIBOLD_DF>
      </div>
    </div>
  );
};


export const WidgetUnderConstructionState = ({ display }) => {
  return (
    <div style={{ padding: "1.6rem", height: "100%" }}>
    <div
      style={{
        minHeight: MIN_HEIGHT+"px",
        background: colors2.grey5,
        height: '100%',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        borderRadius: "6px",
      }}
    >
      <UI_DISPLAY style={{ color: colors2.grey10 }}>{display}</UI_DISPLAY>
    </div>
    </div>
  );
};

/**
 * Neutral "nothing to show yet" state for a widget that is configured but has
 * an empty selection (e.g. metric card with every value unchecked). Same box
 * as the under-construction state, but a readable message instead of the
 * widget name.
 */
export const WidgetEmptyState = ({ display }) => {
  return (
    <div style={{ padding: "1.6rem", height: "100%" }}>
      <div
        className="widget-empty-state"
        style={{
          minHeight: MIN_HEIGHT + "px",
          background: colors2.grey5,
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          borderRadius: "6px",
          padding: "1.6rem",
        }}
      >
        <UI_BODY_SEMIBOLD_DF style={{ color: colors2.grey80 }}>{display}</UI_BODY_SEMIBOLD_DF>
      </div>
    </div>
  );
};
